<template>
  <b-button
    variant="light"
    class="mr-3"
    @click="$router.go(-1)"
  >
    <font-awesome-icon :icon="'chevron-left'" />
    {{ $t('Back') }}
  </b-button>
</template>

<script>
export default {
  name: 'BackButton',
};
</script>

<style scoped>

</style>